'use client';

import {
  PublicPage,
  ThemedPublicPage,
} from '@unifyapps/carbon/no-code/components/PublicPages/PublicPage';
import { useRegistryContext } from '@unifyapps/carbon/no-code/context/RegistryProvider';
import type { InterfaceComponentPage } from '@unifyapps/carbon/no-code/types/interfaceComponent';
import type {
  ApplicationType,
  ColorScheme,
  InterfaceEntity,
} from '@unifyapps/defs/types/interface';
import type { ReactNode } from 'react';
import { RegistryProviderLoader } from './RegistryProvider';

type PublicPageClientWrapperProps = {
  interfaceComponent: InterfaceComponentPage;
  interfaceRecord: InterfaceEntity;
  pageParams?: Record<string, string | undefined>;
  searchParams?: {
    returnTo?: string;
  };
  platform: ApplicationType;
  colorScheme?: ColorScheme;
  interfaceThemeId?: string;
  children?: ReactNode;
  useThemed?: boolean;
};

function PublicPageClient({
  interfaceComponent,
  interfaceRecord,
  pageParams,
  searchParams,
  colorScheme,
  interfaceThemeId,
  children,
  useThemed,
}: PublicPageClientWrapperProps) {
  const Component = useThemed ? ThemedPublicPage : PublicPage;
  const { registry } = useRegistryContext();

  return (
    <Component
      colorScheme={colorScheme}
      interfaceComponent={interfaceComponent}
      interfaceRecord={interfaceRecord}
      interfaceThemeId={interfaceThemeId}
      pageParams={pageParams}
      registry={registry}
      searchParams={searchParams}
    >
      {children}
    </Component>
  );
}

export default function PublicPageClientWrapper(props: PublicPageClientWrapperProps) {
  const { platform } = props;
  return (
    <RegistryProviderLoader platform={platform}>
      <PublicPageClient {...props} />
    </RegistryProviderLoader>
  );
}
